module.exports = __webpack_public_path__ + "img/grid - blue.c4985305.svg";